import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import * as snackbar from 'utils/snackbar'
import { useSession } from 'components/Providers'
import { update } from 'store/needs-attention/address-change'
import { runWidget } from 'store/widget'


export default function useSaveSection(request) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { person } = useSession()
  const [saving, setSaving] = useState(false)

  const save = async (changes, message = 'Address change request updated') => {
    setSaving(true)
    const res = await dispatch(update({ type: 'student', id: request.id, ...changes }))
    setSaving(false)
    if (res.error) return false

    snackbar.success(t(message))
    dispatch(runWidget({ type: person?.type, code: 'needsAttention' }))
    return true
  }

  return { save, saving, setSaving }
}
